import script from "./ButtonPrimary.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonPrimary.vue?vue&type=script&setup=true&lang=js"

import "./ButtonPrimary.vue?vue&type=style&index=0&id=5cb5e21e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cb5e21e"]])

export default __exports__